import React, { useState, useEffect } from 'react';
import { Share, MoreVertical, PlusSquare, Download, X } from 'lucide-react';

const InstallGuide = () => {
  const [show, setShow] = useState(false);
  const [platform, setPlatform] = useState('ios');

  useEffect(() => {
    // 1. Check if already installed
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    
    // 2. Check if user has dismissed it before
    const isDismissed = localStorage.getItem('pwa-guide-dismissed');

    if (!isStandalone && !isDismissed) {
      // Detect platform
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(userAgent)) {
        setPlatform('ios');
        setShow(true);
      } else if (/android/.test(userAgent)) {
        setPlatform('android');
        setShow(true);
      }
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('pwa-guide-dismissed', 'true');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <button onClick={handleDismiss} style={closeBtn}><X size={20} /></button>
        
        <div style={iconHeader}>
          <div style={appIcon}>🍃</div>
        </div>

        <h2 style={titleStyle}>Add to Home Screen</h2>
        <p style={descStyle}>
          Install <b>Leaf & Letter</b> to enjoy a full-screen, cozy reading experience.
        </p>

        <div style={instructionBox}>
          {platform === 'ios' ? (
            <div style={stepList}>
              <div style={step}><span style={num}>1</span> Tap the <b>Share</b> icon <Share size={18} style={inlineIcon} /> below.</div>
              <div style={step}><span style={num}>2</span> Scroll down and tap <b>Add to Home Screen</b> <PlusSquare size={18} style={inlineIcon} />.</div>
              <div style={step}><span style={num}>3</span> Tap <b>Add</b> in the top right.</div>
            </div>
          ) : (
            <div style={stepList}>
              <div style={step}><span style={num}>1</span> Tap the <b>Menu</b> icon <MoreVertical size={18} style={inlineIcon} /> in the top right.</div>
              <div style={step}><span style={num}>2</span> Tap <b>Install App</b> or <b>Add to Home screen</b>.</div>
              <div style={step}><span style={num}>3</span> Confirm by tapping <b>Install</b>.</div>
            </div>
          )}
        </div>

        <button onClick={handleDismiss} style={actionBtn}>Got it, thanks!</button>
      </div>
    </div>
  );
};

// Styles
const overlayStyle = {
  position: 'fixed', bottom: 0, left: 0, right: 0, top: 0,
  backgroundColor: 'rgba(0,0,0,0.7)',
  display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
  zIndex: 5000, padding: '10px'
};

const modalStyle = {
  backgroundColor: 'var(--bg-card)',
  width: '100%', maxWidth: '450px',
  borderRadius: '24px 24px 12px 24px',
  padding: '30px 20px',
  position: 'relative',
  textAlign: 'center',
  boxShadow: '0 -10px 40px rgba(0,0,0,0.2)',
  animation: 'slideUp 0.4s ease-out'
};

const iconHeader = {
  display: 'flex', justifyContent: 'center', marginBottom: '15px'
};

const appIcon = {
  width: '60px', height: '60px', backgroundColor: 'var(--accent-soft)',
  borderRadius: '15px', fontSize: '2rem', display: 'flex',
  alignItems: 'center', justifyContent: 'center'
};

const titleStyle = { margin: '0 0 10px 0', color: 'var(--text-main)' };
const descStyle = { fontSize: '0.9rem', color: 'var(--text-soft)', lineHeight: '1.4', marginBottom: '20px' };

const instructionBox = {
  backgroundColor: 'var(--bg-app)',
  padding: '20px', borderRadius: '16px',
  textAlign: 'left', marginBottom: '20px',
  border: '1px solid var(--border)'
};

const stepList = { display: 'flex', flexDirection: 'column', gap: '12px' };
const step = { fontSize: '0.9rem', color: 'var(--text-main)', display: 'flex', alignItems: 'center', gap: '10px' };
const num = { 
  width: '22px', height: '22px', backgroundColor: 'var(--accent)', 
  color: 'white', borderRadius: '50%', fontSize: '0.7rem', 
  display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' 
};

const inlineIcon = { display: 'inline', verticalAlign: 'middle', margin: '0 2px' };

const actionBtn = {
  width: '100%', padding: '14px', borderRadius: '12px', border: 'none',
  backgroundColor: 'var(--accent)', color: 'white', fontWeight: 'bold', cursor: 'pointer'
};

const closeBtn = {
  position: 'absolute', top: '15px', right: '15px',
  background: 'none', border: 'none', color: 'var(--text-soft)', cursor: 'pointer'
};

export default InstallGuide;
